var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 102,
    height: 102,
    transform: "translate(1048 4136)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_handicraft",
    transform: "translate(-1048 -4136)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gifts",
    transform: "translate(1052.999 4141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M83.943,32.723H81.856a9.06,9.06,0,0,0,.982-.847,8.81,8.81,0,0,0,2.348-3.513,3.084,3.084,0,0,0-4-4,8.83,8.83,0,0,0-3.513,2.348A12.482,12.482,0,0,0,75.4,30.073a12.482,12.482,0,0,0-2.269-3.359,8.811,8.811,0,0,0-3.513-2.348,3.084,3.084,0,0,0-4,4,8.83,8.83,0,0,0,2.348,3.513,9.385,9.385,0,0,0,.982.847H66.87a7.04,7.04,0,0,0-4.268,1.46V27.032a7.122,7.122,0,0,0-7.114-7.114h-16.1A27.956,27.956,0,0,0,47.3,14.707c2.641-2.641,4.325-5.13,5.007-7.4a5.609,5.609,0,0,0-1.138-5.833A5.6,5.6,0,0,0,45.335.336c-2.269.682-4.759,2.365-7.4,5.007-3.2,3.194-5.364,7.9-6.634,11.327-1.271-3.425-3.439-8.132-6.634-11.327-2.641-2.642-5.13-4.325-7.4-5.007a5.6,5.6,0,0,0-5.833,1.138A5.609,5.609,0,0,0,10.3,7.307c.68,2.269,2.365,4.759,5.007,7.4a27.936,27.936,0,0,0,7.911,5.212H7.114A7.122,7.122,0,0,0,0,27.032v56.91a7.122,7.122,0,0,0,7.114,7.114H83.943a7.122,7.122,0,0,0,7.114-7.114V39.837A7.122,7.122,0,0,0,83.943,32.723ZM17.073,68.292H38.414v5.691H17.073Zm21.341-2.846H17.073V58.333a4.273,4.273,0,0,1,4.268-4.268H38.414ZM36.544,47.271a8.43,8.43,0,0,1-2.3-3.291c-.157-.521-.127-.895.088-1.11a.73.73,0,0,1,.535-.188,1.993,1.993,0,0,1,.576.1,8.429,8.429,0,0,1,3.289,2.3,15.974,15.974,0,0,1,3.149,5.338A15.969,15.969,0,0,1,36.544,47.271Zm9.784,3.149a15.974,15.974,0,0,1,3.149-5.338,8.439,8.439,0,0,1,3.289-2.3,1.968,1.968,0,0,1,.578-.1.724.724,0,0,1,.534.188c.215.215.246.589.088,1.11a8.44,8.44,0,0,1-2.3,3.291A15.97,15.97,0,0,1,46.328,50.42ZM66.87,54.065a4.273,4.273,0,0,1,4.268,4.268v7.114H49.8V54.065ZM49.8,68.292H71.138v5.691H49.8Zm24.187,15.65V58.333a7.04,7.04,0,0,0-1.46-4.268h.037v-18.5h5.691V88.211H72.524A7.04,7.04,0,0,0,73.983,83.943Zm5.7-55.217A6.02,6.02,0,0,1,82,27.091a1.25,1.25,0,0,1,.336-.058.225.225,0,0,1,.144.036c.055.055.046.249-.023.479a6.02,6.02,0,0,1-1.635,2.318,10.4,10.4,0,0,1-3.1,1.961A10.5,10.5,0,0,1,79.687,28.725ZM68.328,27.068a.225.225,0,0,1,.144-.036,1.268,1.268,0,0,1,.336.058,6.02,6.02,0,0,1,2.318,1.635,10.4,10.4,0,0,1,1.961,3.1,10.558,10.558,0,0,1-3.1-1.958,6.02,6.02,0,0,1-1.635-2.318C68.282,27.317,68.272,27.125,68.328,27.068Zm-1.458,8.5h2.846V51.822a7.043,7.043,0,0,0-2.846-.6H62.6V39.837A4.273,4.273,0,0,1,66.87,35.569ZM39.947,7.354c2.871-2.87,4.958-3.918,6.2-4.292a4.661,4.661,0,0,1,1.327-.218,2.273,2.273,0,0,1,1.677.642,2.846,2.846,0,0,1,.424,3c-.374,1.246-1.421,3.335-4.292,6.2-3.314,3.314-8.726,5.476-11.866,6.523C34.469,16.081,36.626,10.675,39.947,7.354ZM13.021,6.49a2.852,2.852,0,0,1,.424-3,2.267,2.267,0,0,1,1.676-.642,4.678,4.678,0,0,1,1.329.218c1.246.374,3.335,1.421,6.2,4.292,3.314,3.314,5.476,8.726,6.523,11.866-3.137-1.046-8.544-3.2-11.864-6.525C14.442,9.824,13.4,7.737,13.021,6.49ZM2.846,83.943V27.032a4.273,4.273,0,0,1,4.268-4.268H27.866l-4.685,4.685a1.417,1.417,0,0,0-.417,1.006V34.98l-2.429,2.429,2.012,2.012,2.846-2.846a1.422,1.422,0,0,0,.417-1.006V29.044L31.3,23.353l5.691,5.691v6.525a1.417,1.417,0,0,0,.417,1.006l2.846,2.846,2.012-2.012L39.837,34.98V28.455a1.422,1.422,0,0,0-.417-1.006l-4.685-4.685H55.488a4.273,4.273,0,0,1,4.268,4.268V51.219h-8.6a13.671,13.671,0,0,0,2.52-1.936A11.328,11.328,0,0,0,56.691,44.8a3.644,3.644,0,0,0-4.742-4.742,11.313,11.313,0,0,0-4.485,3.013,17.357,17.357,0,0,0-3.359,5.277,17.357,17.357,0,0,0-3.359-5.277,11.313,11.313,0,0,0-4.485-3.013A3.644,3.644,0,0,0,31.521,44.8a11.319,11.319,0,0,0,3.013,4.485,13.643,13.643,0,0,0,2.52,1.936H21.341a7.122,7.122,0,0,0-7.114,7.114v25.61a7.04,7.04,0,0,0,1.46,4.268H7.114A4.273,4.273,0,0,1,2.846,83.943Zm14.228,0V76.829H38.414V88.211H21.341A4.273,4.273,0,0,1,17.073,83.943ZM41.26,88.211V54.065h5.691V88.211Zm19.919,0H49.8V76.829H71.138v7.114a4.273,4.273,0,0,1-4.268,4.268Zm27.032-4.268a4.273,4.273,0,0,1-4.268,4.268H81.1V35.569h2.846a4.273,4.273,0,0,1,4.268,4.268Z",
    transform: "translate(0 0)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 2,
    height: 5,
    transform: "translate(74.056 0.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 2,
    height: 4,
    transform: "translate(74.056 8.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 2,
    height: 5,
    transform: "translate(74.056 15.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_996",
    "data-name": "Rectangle 996",
    width: 6,
    height: 4,
    transform: "translate(80.056 8.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_997",
    "data-name": "Rectangle 997",
    width: 5,
    height: 4,
    transform: "translate(66.056 8.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_998",
    "data-name": "Rectangle 998",
    width: 3,
    height: 4,
    transform: "translate(5.056 31.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_999",
    "data-name": "Rectangle 999",
    width: 3,
    height: 3,
    transform: "translate(5.056 37.056)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1000",
    "data-name": "Rectangle 1000",
    width: 3,
    height: 3,
    transform: "translate(5.056 25.056)",
    fill: "#f9556d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs3);
export default __webpack_public_path__ + "static/media/ss3.699c70428f2042f7c0f2243a5c1d36d8.svg";
export { ForwardRef as ReactComponent };